export class UploadFileModel {
    name: string;
    lastModified: string;
    lastModifiedDate: Date;
    webkitRelativePath: number;
    size: number;
    type: string;
}